let OffersList = (function () {
    let filters = {};
    let getFilters = function () {
        filters = {}; //clear previous filters
        var checkedOfferTypes = [];
        //get checked filters for offer type
        jQuery('#offer-type-input-wrapper input[type="checkbox"]:checked').each(function () {
            checkedOfferTypes.push(jQuery(this).data('offer-type'));
        });
        //check for offer type filters
        if (checkedOfferTypes.length > 0) {
            filters.offer = checkedOfferTypes;
        }
    };
    let filterOffers = function (filters, offers) {
        var filteredOffers = [];
        jQuery(offers).each(function () {
            //if filters are present
            if (filters.offer) {
                //if offer meets filter criteria add to filtered array
                if (filters.offer.includes(parseInt(this.CategoryId))) {
                    filteredOffers.push(this);
                }
            }
            //otherwise do not filter
            else {
                filteredOffers = offers;
            }
        });
        return filteredOffers;
    };
    let registerEventHandlers = function (offers) {
        jQuery('input[type="checkbox"]').on('change', function () {
            OffersList.loadOffers(offers);
        });
        jQuery('#offer-type-filter-tab').on('click', function () {
            jQuery('#offer-type-input-wrapper').slideToggle(100, 'linear');
            jQuery(this).find('i').toggleClass('fa-angle-down').toggleClass('fa-angle-right');
        });
    };
    let updateHTML = function (filteredOffers) {
        //use template and filters to build HTML and add to page
        var offersHTML = filteredOffers.reduce((accumulator, {
            CategoryId,
            CouponId,
            CouponType,
            CouponName,
            CouponURL,
            DollarAmount,
            Description,
            SubTitle
        }) => {
            return accumulator += `
                <div class="offer-box" data-offer-type="${CategoryId}">
                    <div class="offer-text">
                        <h4>
                            ${(DollarAmount && CouponType === 'Coupon') ? `<span>$</span>` : ``}${CouponName} ${SubTitle} 
                        </h4>
                        <p class="coupon-desc">${Description}</p>
                    </div>
                    <div class="offer-button-wrapper">
                        <a href="/${(CouponType === 'Promotion')? `promotion` : `coupon`}/${CouponURL}" class="monro-button monro-button-yellow short d-none d-lg-block d-xl-block">
                            DETAILS
                        </a>
                        <a href="/${(CouponType === 'Promotion')? `promotion` : `coupon`}/${CouponURL}" class="monro-button monro-button-yellow short d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
                            DETAILS
                        </a>
                    </div>
                </div>`;
        }, '');
        //if no results, display message in 
        if (offersHTML.length === 0) {
            offersHTML = '<div class="alert alert-primary" role="alert">No results found</div>';
        }
        jQuery('#offers-list-wrapper').html(offersHTML);
    };
    let loadOffers = function (offers) {
        getFilters(); //determine which filters are selected
        var filteredOffers = filterOffers(filters, offers); //filter the offers array
        updateHTML(filteredOffers); //display filtered offers
    };
    return {
        loadOffers: loadOffers,
        registerEventHandlers: registerEventHandlers
    };
})();